<template>
  <div>
    <el-table
      v-if="showTable"
      :data="activityList"
      border
      :header-row-style="tableHeaderStyle"
      :header-cell-style="tableHeaderStyle"
      empty-text="ไม่พบข้อมูล"
    >
      <el-table-column
        type="index"
        label="ลำดับ"
        header-align="center"
        align="center"
        sortable
        :width="
          widthMax < 767.98
            ? '60'
            : widthMax < 1199
            ? '60'
            : widthMax > 1200
            ? '80'
            : ''
        "
      ></el-table-column>
      <el-table-column
        prop="name"
        label="ชื่อหลักสูตร"
        header-align="center"
        sortable
        :width="widthMax < 767.98 ? '120' : widthMax < 1199 ? '130' : ''"
      ></el-table-column>
      <el-table-column
        prop="durationTime"
        label="เปิด-ปิดหลักสูตร"
        header-align="center"
        align="center"
        width="350"
      >
        <template slot-scope="scope">
          {{ scope.row.durationTime.open | dateTimeThShort }} -
          {{ new Date(scope.row.durationTime.close).setHours(23,59,59) | dateTimeThShort }}
        </template>
      </el-table-column>
      <el-table-column
        prop="subject"
        label="จำนวนวิชา"
        header-align="center"
        align="center"
        width="120"
      >
      </el-table-column>
       <el-table-column
        v-if="doneCourse"
        prop="coursePercent"
        label="% การผ่านของหลักสูตร"
        width="120"
        header-align="center"
        align="center"
        sortable
      >
        <template slot-scope="scope">
          <p>{{ scope.row.coursePercent ? scope.row.coursePercent.toFixed(0) : 0 }}%</p>
        </template>
      </el-table-column>
      <el-table-column
        v-if="doneCourse"
        prop="percent"
        label="คะแนนรวม (100%)"
        width="120"
        header-align="center"
        align="center"
        sortable
      >
        <template slot-scope="scope">
          <p>{{ scope.row.percent ? scope.row.percent.toFixed(0) : 0 }}%</p>
        </template>
      </el-table-column>
      <el-table-column
        v-if="doneCourse"
        prop="pass"
        label="สถานะ"
        width="65"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <p v-if="scope.row.pass" class="color-success">ผ่าน</p>
          <p v-else class="color-danger">ไม่ผ่าน</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        :label="doneCourse ? 'วันและเวลาที่จบหลักสูตร' : 'วันและเวลาที่อัปเดตล่าสุด'"
        :width="
          widthMax < 767.98
            ? '160'
            : widthMax < 1199
            ? '160'
            : widthMax > 1200
            ? '250'
            : ''
        "
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">{{
          scope.row.updatedAt | dateTimeTh
        }}</template>
      </el-table-column>
      <el-table-column
        label
        :width="doneCourse?'100':'50'"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <div class="flex-display ai-center js-center">
            <div class="box-action">
              <div
                @click="
                  doneCourse?$router.push(
                    `/name/list/grudate?courseId=${scope.row.courseId}&userId=${userId}`
                  ):$router.push(
                    `/name/list/learning?courseId=${scope.row.courseId}&userId=${userId}`
                  )
                "
                class="circle-action color-bg-secondary"
              >
                <i class="fas fa-eye"></i>
              </div>
            </div>
            <div  v-if="doneCourse" class="box-action">
              <div
                @click="printCertificate(scope.row.name, scope.row.updatedAt)"
                class="circle-action color-bg-secondary"
              >
                <i class="fas fa-print"></i>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { tableHeaderStyle } from "@/service/table";

export default {
  props: {
    doneCourse: {
      type: Boolean,
      default() {
        return true;
      },
    },
    activityList: {
      type: Array,
      default() {
        return [];
      },
    },
    userId: {
      type: String,
      default() {
        return '';
      },
    },
  },
  computed: {
    assignmentList() {
      return this.assignmentListConst.slice(
        (this.page - 1) * 10,
        this.page * 10
      );
    },
  },
  data() {
    return {
      widthMax: window.innerWidth,
      showTable:true
    };
  },
  mounted() {
    window.addEventListener("resize", this.resize);
  },
  methods: {
    resize() {
      this.showTable = false
      this.widthMax= window.innerWidth
      setTimeout(() => {
        this.showTable = true
      }, 200);

    },
    printCertificate(name, endDate) {
      this.$emit("printCertificate", name, endDate);
    },
  },
};
</script>